import m from "./index299.mjs";
import w from "./index300.mjs";
import C from "./index301.mjs";
import v from "./index302.mjs";
import D from "./index303.mjs";
import h from "./index304.mjs";
import p from "./index305.mjs";
var U = 36e5, M = 6e4, k = 1e3, s = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, d = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function i(t, r, e) {
  var n = r.match(t);
  if (!n)
    return null;
  var o = parseInt(n[0], 10);
  return {
    value: e ? e(o) : o,
    rest: r.slice(n[0].length)
  };
}
function f(t, r) {
  var e = r.match(t);
  if (!e)
    return null;
  if (e[0] === "Z")
    return {
      value: 0,
      rest: r.slice(1)
    };
  var n = e[1] === "+" ? 1 : -1, o = e[2] ? parseInt(e[2], 10) : 0, a = e[3] ? parseInt(e[3], 10) : 0, c = e[5] ? parseInt(e[5], 10) : 0;
  return {
    value: n * (o * U + a * M + c * k),
    rest: r.slice(e[0].length)
  };
}
function _(t, r) {
  return i(s.anyDigitsSigned, t, r);
}
function u(t, r, e) {
  switch (t) {
    case 1:
      return i(s.singleDigit, r, e);
    case 2:
      return i(s.twoDigits, r, e);
    case 3:
      return i(s.threeDigits, r, e);
    case 4:
      return i(s.fourDigits, r, e);
    default:
      return i(new RegExp("^\\d{1," + t + "}"), r, e);
  }
}
function l(t, r, e) {
  switch (t) {
    case 1:
      return i(s.singleDigitSigned, r, e);
    case 2:
      return i(s.twoDigitsSigned, r, e);
    case 3:
      return i(s.threeDigitsSigned, r, e);
    case 4:
      return i(s.fourDigitsSigned, r, e);
    default:
      return i(new RegExp("^-?\\d{1," + t + "}"), r, e);
  }
}
function b(t) {
  switch (t) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function y(t, r) {
  var e = r > 0, n = e ? r : 1 - r, o;
  if (n <= 50)
    o = t || 100;
  else {
    var a = n + 50, c = Math.floor(a / 100) * 100, x = t >= a % 100;
    o = t + c - (x ? 100 : 0);
  }
  return e ? o : 1 - o;
}
var q = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Y = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function T(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
var P = {
  // Era
  G: {
    priority: 140,
    parse: function(t, r, e, n) {
      switch (r) {
        case "G":
        case "GG":
        case "GGG":
          return e.era(t, {
            width: "abbreviated"
          }) || e.era(t, {
            width: "narrow"
          });
        case "GGGGG":
          return e.era(t, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return e.era(t, {
            width: "wide"
          }) || e.era(t, {
            width: "abbreviated"
          }) || e.era(t, {
            width: "narrow"
          });
      }
    },
    set: function(t, r, e, n) {
      return r.era = e, t.setUTCFullYear(e, 0, 1), t.setUTCHours(0, 0, 0, 0), t;
    },
    incompatibleTokens: ["R", "u", "t", "T"]
  },
  // Year
  y: {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    priority: 130,
    parse: function(t, r, e, n) {
      var o = function(a) {
        return {
          year: a,
          isTwoDigitYear: r === "yy"
        };
      };
      switch (r) {
        case "y":
          return u(4, t, o);
        case "yo":
          return e.ordinalNumber(t, {
            unit: "year",
            valueCallback: o
          });
        default:
          return u(r.length, t, o);
      }
    },
    validate: function(t, r, e) {
      return r.isTwoDigitYear || r.year > 0;
    },
    set: function(t, r, e, n) {
      var o = t.getUTCFullYear();
      if (e.isTwoDigitYear) {
        var a = y(e.year, o);
        return t.setUTCFullYear(a, 0, 1), t.setUTCHours(0, 0, 0, 0), t;
      }
      var c = !("era" in r) || r.era === 1 ? e.year : 1 - e.year;
      return t.setUTCFullYear(c, 0, 1), t.setUTCHours(0, 0, 0, 0), t;
    },
    incompatibleTokens: ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]
  },
  // Local week-numbering year
  Y: {
    priority: 130,
    parse: function(t, r, e, n) {
      var o = function(a) {
        return {
          year: a,
          isTwoDigitYear: r === "YY"
        };
      };
      switch (r) {
        case "Y":
          return u(4, t, o);
        case "Yo":
          return e.ordinalNumber(t, {
            unit: "year",
            valueCallback: o
          });
        default:
          return u(r.length, t, o);
      }
    },
    validate: function(t, r, e) {
      return r.isTwoDigitYear || r.year > 0;
    },
    set: function(t, r, e, n) {
      var o = m(t, n);
      if (e.isTwoDigitYear) {
        var a = y(e.year, o);
        return t.setUTCFullYear(a, 0, n.firstWeekContainsDate), t.setUTCHours(0, 0, 0, 0), p(t, n);
      }
      var c = !("era" in r) || r.era === 1 ? e.year : 1 - e.year;
      return t.setUTCFullYear(c, 0, n.firstWeekContainsDate), t.setUTCHours(0, 0, 0, 0), p(t, n);
    },
    incompatibleTokens: ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]
  },
  // ISO week-numbering year
  R: {
    priority: 130,
    parse: function(t, r, e, n) {
      return l(r === "R" ? 4 : r.length, t);
    },
    set: function(t, r, e, n) {
      var o = /* @__PURE__ */ new Date(0);
      return o.setUTCFullYear(e, 0, 4), o.setUTCHours(0, 0, 0, 0), h(o);
    },
    incompatibleTokens: ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]
  },
  // Extended year
  u: {
    priority: 130,
    parse: function(t, r, e, n) {
      return l(r === "u" ? 4 : r.length, t);
    },
    set: function(t, r, e, n) {
      return t.setUTCFullYear(e, 0, 1), t.setUTCHours(0, 0, 0, 0), t;
    },
    incompatibleTokens: ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]
  },
  // Quarter
  Q: {
    priority: 120,
    parse: function(t, r, e, n) {
      switch (r) {
        case "Q":
        case "QQ":
          return u(r.length, t);
        case "Qo":
          return e.ordinalNumber(t, {
            unit: "quarter"
          });
        case "QQQ":
          return e.quarter(t, {
            width: "abbreviated",
            context: "formatting"
          }) || e.quarter(t, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return e.quarter(t, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return e.quarter(t, {
            width: "wide",
            context: "formatting"
          }) || e.quarter(t, {
            width: "abbreviated",
            context: "formatting"
          }) || e.quarter(t, {
            width: "narrow",
            context: "formatting"
          });
      }
    },
    validate: function(t, r, e) {
      return r >= 1 && r <= 4;
    },
    set: function(t, r, e, n) {
      return t.setUTCMonth((e - 1) * 3, 1), t.setUTCHours(0, 0, 0, 0), t;
    },
    incompatibleTokens: ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]
  },
  // Stand-alone quarter
  q: {
    priority: 120,
    parse: function(t, r, e, n) {
      switch (r) {
        case "q":
        case "qq":
          return u(r.length, t);
        case "qo":
          return e.ordinalNumber(t, {
            unit: "quarter"
          });
        case "qqq":
          return e.quarter(t, {
            width: "abbreviated",
            context: "standalone"
          }) || e.quarter(t, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return e.quarter(t, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return e.quarter(t, {
            width: "wide",
            context: "standalone"
          }) || e.quarter(t, {
            width: "abbreviated",
            context: "standalone"
          }) || e.quarter(t, {
            width: "narrow",
            context: "standalone"
          });
      }
    },
    validate: function(t, r, e) {
      return r >= 1 && r <= 4;
    },
    set: function(t, r, e, n) {
      return t.setUTCMonth((e - 1) * 3, 1), t.setUTCHours(0, 0, 0, 0), t;
    },
    incompatibleTokens: ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]
  },
  // Month
  M: {
    priority: 110,
    parse: function(t, r, e, n) {
      var o = function(a) {
        return a - 1;
      };
      switch (r) {
        case "M":
          return i(s.month, t, o);
        case "MM":
          return u(2, t, o);
        case "Mo":
          return e.ordinalNumber(t, {
            unit: "month",
            valueCallback: o
          });
        case "MMM":
          return e.month(t, {
            width: "abbreviated",
            context: "formatting"
          }) || e.month(t, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return e.month(t, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return e.month(t, {
            width: "wide",
            context: "formatting"
          }) || e.month(t, {
            width: "abbreviated",
            context: "formatting"
          }) || e.month(t, {
            width: "narrow",
            context: "formatting"
          });
      }
    },
    validate: function(t, r, e) {
      return r >= 0 && r <= 11;
    },
    set: function(t, r, e, n) {
      return t.setUTCMonth(e, 1), t.setUTCHours(0, 0, 0, 0), t;
    },
    incompatibleTokens: ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]
  },
  // Stand-alone month
  L: {
    priority: 110,
    parse: function(t, r, e, n) {
      var o = function(a) {
        return a - 1;
      };
      switch (r) {
        case "L":
          return i(s.month, t, o);
        case "LL":
          return u(2, t, o);
        case "Lo":
          return e.ordinalNumber(t, {
            unit: "month",
            valueCallback: o
          });
        case "LLL":
          return e.month(t, {
            width: "abbreviated",
            context: "standalone"
          }) || e.month(t, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLLL":
          return e.month(t, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return e.month(t, {
            width: "wide",
            context: "standalone"
          }) || e.month(t, {
            width: "abbreviated",
            context: "standalone"
          }) || e.month(t, {
            width: "narrow",
            context: "standalone"
          });
      }
    },
    validate: function(t, r, e) {
      return r >= 0 && r <= 11;
    },
    set: function(t, r, e, n) {
      return t.setUTCMonth(e, 1), t.setUTCHours(0, 0, 0, 0), t;
    },
    incompatibleTokens: ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]
  },
  // Local week of year
  w: {
    priority: 100,
    parse: function(t, r, e, n) {
      switch (r) {
        case "w":
          return i(s.week, t);
        case "wo":
          return e.ordinalNumber(t, {
            unit: "week"
          });
        default:
          return u(r.length, t);
      }
    },
    validate: function(t, r, e) {
      return r >= 1 && r <= 53;
    },
    set: function(t, r, e, n) {
      return p(D(t, e, n), n);
    },
    incompatibleTokens: ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]
  },
  // ISO week of year
  I: {
    priority: 100,
    parse: function(t, r, e, n) {
      switch (r) {
        case "I":
          return i(s.week, t);
        case "Io":
          return e.ordinalNumber(t, {
            unit: "week"
          });
        default:
          return u(r.length, t);
      }
    },
    validate: function(t, r, e) {
      return r >= 1 && r <= 53;
    },
    set: function(t, r, e, n) {
      return h(v(t, e, n), n);
    },
    incompatibleTokens: ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]
  },
  // Day of the month
  d: {
    priority: 90,
    subPriority: 1,
    parse: function(t, r, e, n) {
      switch (r) {
        case "d":
          return i(s.date, t);
        case "do":
          return e.ordinalNumber(t, {
            unit: "date"
          });
        default:
          return u(r.length, t);
      }
    },
    validate: function(t, r, e) {
      var n = t.getUTCFullYear(), o = T(n), a = t.getUTCMonth();
      return o ? r >= 1 && r <= Y[a] : r >= 1 && r <= q[a];
    },
    set: function(t, r, e, n) {
      return t.setUTCDate(e), t.setUTCHours(0, 0, 0, 0), t;
    },
    incompatibleTokens: ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]
  },
  // Day of year
  D: {
    priority: 90,
    subPriority: 1,
    parse: function(t, r, e, n) {
      switch (r) {
        case "D":
        case "DD":
          return i(s.dayOfYear, t);
        case "Do":
          return e.ordinalNumber(t, {
            unit: "date"
          });
        default:
          return u(r.length, t);
      }
    },
    validate: function(t, r, e) {
      var n = t.getUTCFullYear(), o = T(n);
      return o ? r >= 1 && r <= 366 : r >= 1 && r <= 365;
    },
    set: function(t, r, e, n) {
      return t.setUTCMonth(0, e), t.setUTCHours(0, 0, 0, 0), t;
    },
    incompatibleTokens: ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]
  },
  // Day of week
  E: {
    priority: 90,
    parse: function(t, r, e, n) {
      switch (r) {
        case "E":
        case "EE":
        case "EEE":
          return e.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || e.day(t, {
            width: "short",
            context: "formatting"
          }) || e.day(t, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEE":
          return e.day(t, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return e.day(t, {
            width: "short",
            context: "formatting"
          }) || e.day(t, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEE":
        default:
          return e.day(t, {
            width: "wide",
            context: "formatting"
          }) || e.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || e.day(t, {
            width: "short",
            context: "formatting"
          }) || e.day(t, {
            width: "narrow",
            context: "formatting"
          });
      }
    },
    validate: function(t, r, e) {
      return r >= 0 && r <= 6;
    },
    set: function(t, r, e, n) {
      return t = w(t, e, n), t.setUTCHours(0, 0, 0, 0), t;
    },
    incompatibleTokens: ["D", "i", "e", "c", "t", "T"]
  },
  // Local day of week
  e: {
    priority: 90,
    parse: function(t, r, e, n) {
      var o = function(a) {
        var c = Math.floor((a - 1) / 7) * 7;
        return (a + n.weekStartsOn + 6) % 7 + c;
      };
      switch (r) {
        case "e":
        case "ee":
          return u(r.length, t, o);
        case "eo":
          return e.ordinalNumber(t, {
            unit: "day",
            valueCallback: o
          });
        case "eee":
          return e.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || e.day(t, {
            width: "short",
            context: "formatting"
          }) || e.day(t, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return e.day(t, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return e.day(t, {
            width: "short",
            context: "formatting"
          }) || e.day(t, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return e.day(t, {
            width: "wide",
            context: "formatting"
          }) || e.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || e.day(t, {
            width: "short",
            context: "formatting"
          }) || e.day(t, {
            width: "narrow",
            context: "formatting"
          });
      }
    },
    validate: function(t, r, e) {
      return r >= 0 && r <= 6;
    },
    set: function(t, r, e, n) {
      return t = w(t, e, n), t.setUTCHours(0, 0, 0, 0), t;
    },
    incompatibleTokens: ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]
  },
  // Stand-alone local day of week
  c: {
    priority: 90,
    parse: function(t, r, e, n) {
      var o = function(a) {
        var c = Math.floor((a - 1) / 7) * 7;
        return (a + n.weekStartsOn + 6) % 7 + c;
      };
      switch (r) {
        case "c":
        case "cc":
          return u(r.length, t, o);
        case "co":
          return e.ordinalNumber(t, {
            unit: "day",
            valueCallback: o
          });
        case "ccc":
          return e.day(t, {
            width: "abbreviated",
            context: "standalone"
          }) || e.day(t, {
            width: "short",
            context: "standalone"
          }) || e.day(t, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return e.day(t, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return e.day(t, {
            width: "short",
            context: "standalone"
          }) || e.day(t, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return e.day(t, {
            width: "wide",
            context: "standalone"
          }) || e.day(t, {
            width: "abbreviated",
            context: "standalone"
          }) || e.day(t, {
            width: "short",
            context: "standalone"
          }) || e.day(t, {
            width: "narrow",
            context: "standalone"
          });
      }
    },
    validate: function(t, r, e) {
      return r >= 0 && r <= 6;
    },
    set: function(t, r, e, n) {
      return t = w(t, e, n), t.setUTCHours(0, 0, 0, 0), t;
    },
    incompatibleTokens: ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]
  },
  // ISO day of week
  i: {
    priority: 90,
    parse: function(t, r, e, n) {
      var o = function(a) {
        return a === 0 ? 7 : a;
      };
      switch (r) {
        case "i":
        case "ii":
          return u(r.length, t);
        case "io":
          return e.ordinalNumber(t, {
            unit: "day"
          });
        case "iii":
          return e.day(t, {
            width: "abbreviated",
            context: "formatting",
            valueCallback: o
          }) || e.day(t, {
            width: "short",
            context: "formatting",
            valueCallback: o
          }) || e.day(t, {
            width: "narrow",
            context: "formatting",
            valueCallback: o
          });
        case "iiiii":
          return e.day(t, {
            width: "narrow",
            context: "formatting",
            valueCallback: o
          });
        case "iiiiii":
          return e.day(t, {
            width: "short",
            context: "formatting",
            valueCallback: o
          }) || e.day(t, {
            width: "narrow",
            context: "formatting",
            valueCallback: o
          });
        case "iiii":
        default:
          return e.day(t, {
            width: "wide",
            context: "formatting",
            valueCallback: o
          }) || e.day(t, {
            width: "abbreviated",
            context: "formatting",
            valueCallback: o
          }) || e.day(t, {
            width: "short",
            context: "formatting",
            valueCallback: o
          }) || e.day(t, {
            width: "narrow",
            context: "formatting",
            valueCallback: o
          });
      }
    },
    validate: function(t, r, e) {
      return r >= 1 && r <= 7;
    },
    set: function(t, r, e, n) {
      return t = C(t, e, n), t.setUTCHours(0, 0, 0, 0), t;
    },
    incompatibleTokens: ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]
  },
  // AM or PM
  a: {
    priority: 80,
    parse: function(t, r, e, n) {
      switch (r) {
        case "a":
        case "aa":
        case "aaa":
          return e.dayPeriod(t, {
            width: "abbreviated",
            context: "formatting"
          }) || e.dayPeriod(t, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return e.dayPeriod(t, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return e.dayPeriod(t, {
            width: "wide",
            context: "formatting"
          }) || e.dayPeriod(t, {
            width: "abbreviated",
            context: "formatting"
          }) || e.dayPeriod(t, {
            width: "narrow",
            context: "formatting"
          });
      }
    },
    set: function(t, r, e, n) {
      return t.setUTCHours(b(e), 0, 0, 0), t;
    },
    incompatibleTokens: ["b", "B", "H", "K", "k", "t", "T"]
  },
  // AM, PM, midnight
  b: {
    priority: 80,
    parse: function(t, r, e, n) {
      switch (r) {
        case "b":
        case "bb":
        case "bbb":
          return e.dayPeriod(t, {
            width: "abbreviated",
            context: "formatting"
          }) || e.dayPeriod(t, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return e.dayPeriod(t, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return e.dayPeriod(t, {
            width: "wide",
            context: "formatting"
          }) || e.dayPeriod(t, {
            width: "abbreviated",
            context: "formatting"
          }) || e.dayPeriod(t, {
            width: "narrow",
            context: "formatting"
          });
      }
    },
    set: function(t, r, e, n) {
      return t.setUTCHours(b(e), 0, 0, 0), t;
    },
    incompatibleTokens: ["a", "B", "H", "K", "k", "t", "T"]
  },
  // in the morning, in the afternoon, in the evening, at night
  B: {
    priority: 80,
    parse: function(t, r, e, n) {
      switch (r) {
        case "B":
        case "BB":
        case "BBB":
          return e.dayPeriod(t, {
            width: "abbreviated",
            context: "formatting"
          }) || e.dayPeriod(t, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return e.dayPeriod(t, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return e.dayPeriod(t, {
            width: "wide",
            context: "formatting"
          }) || e.dayPeriod(t, {
            width: "abbreviated",
            context: "formatting"
          }) || e.dayPeriod(t, {
            width: "narrow",
            context: "formatting"
          });
      }
    },
    set: function(t, r, e, n) {
      return t.setUTCHours(b(e), 0, 0, 0), t;
    },
    incompatibleTokens: ["a", "b", "t", "T"]
  },
  // Hour [1-12]
  h: {
    priority: 70,
    parse: function(t, r, e, n) {
      switch (r) {
        case "h":
          return i(s.hour12h, t);
        case "ho":
          return e.ordinalNumber(t, {
            unit: "hour"
          });
        default:
          return u(r.length, t);
      }
    },
    validate: function(t, r, e) {
      return r >= 1 && r <= 12;
    },
    set: function(t, r, e, n) {
      var o = t.getUTCHours() >= 12;
      return o && e < 12 ? t.setUTCHours(e + 12, 0, 0, 0) : !o && e === 12 ? t.setUTCHours(0, 0, 0, 0) : t.setUTCHours(e, 0, 0, 0), t;
    },
    incompatibleTokens: ["H", "K", "k", "t", "T"]
  },
  // Hour [0-23]
  H: {
    priority: 70,
    parse: function(t, r, e, n) {
      switch (r) {
        case "H":
          return i(s.hour23h, t);
        case "Ho":
          return e.ordinalNumber(t, {
            unit: "hour"
          });
        default:
          return u(r.length, t);
      }
    },
    validate: function(t, r, e) {
      return r >= 0 && r <= 23;
    },
    set: function(t, r, e, n) {
      return t.setUTCHours(e, 0, 0, 0), t;
    },
    incompatibleTokens: ["a", "b", "h", "K", "k", "t", "T"]
  },
  // Hour [0-11]
  K: {
    priority: 70,
    parse: function(t, r, e, n) {
      switch (r) {
        case "K":
          return i(s.hour11h, t);
        case "Ko":
          return e.ordinalNumber(t, {
            unit: "hour"
          });
        default:
          return u(r.length, t);
      }
    },
    validate: function(t, r, e) {
      return r >= 0 && r <= 11;
    },
    set: function(t, r, e, n) {
      var o = t.getUTCHours() >= 12;
      return o && e < 12 ? t.setUTCHours(e + 12, 0, 0, 0) : t.setUTCHours(e, 0, 0, 0), t;
    },
    incompatibleTokens: ["a", "b", "h", "H", "k", "t", "T"]
  },
  // Hour [1-24]
  k: {
    priority: 70,
    parse: function(t, r, e, n) {
      switch (r) {
        case "k":
          return i(s.hour24h, t);
        case "ko":
          return e.ordinalNumber(t, {
            unit: "hour"
          });
        default:
          return u(r.length, t);
      }
    },
    validate: function(t, r, e) {
      return r >= 1 && r <= 24;
    },
    set: function(t, r, e, n) {
      var o = e <= 24 ? e % 24 : e;
      return t.setUTCHours(o, 0, 0, 0), t;
    },
    incompatibleTokens: ["a", "b", "h", "H", "K", "t", "T"]
  },
  // Minute
  m: {
    priority: 60,
    parse: function(t, r, e, n) {
      switch (r) {
        case "m":
          return i(s.minute, t);
        case "mo":
          return e.ordinalNumber(t, {
            unit: "minute"
          });
        default:
          return u(r.length, t);
      }
    },
    validate: function(t, r, e) {
      return r >= 0 && r <= 59;
    },
    set: function(t, r, e, n) {
      return t.setUTCMinutes(e, 0, 0), t;
    },
    incompatibleTokens: ["t", "T"]
  },
  // Second
  s: {
    priority: 50,
    parse: function(t, r, e, n) {
      switch (r) {
        case "s":
          return i(s.second, t);
        case "so":
          return e.ordinalNumber(t, {
            unit: "second"
          });
        default:
          return u(r.length, t);
      }
    },
    validate: function(t, r, e) {
      return r >= 0 && r <= 59;
    },
    set: function(t, r, e, n) {
      return t.setUTCSeconds(e, 0), t;
    },
    incompatibleTokens: ["t", "T"]
  },
  // Fraction of second
  S: {
    priority: 30,
    parse: function(t, r, e, n) {
      var o = function(a) {
        return Math.floor(a * Math.pow(10, -r.length + 3));
      };
      return u(r.length, t, o);
    },
    set: function(t, r, e, n) {
      return t.setUTCMilliseconds(e), t;
    },
    incompatibleTokens: ["t", "T"]
  },
  // Timezone (ISO-8601. +00:00 is `'Z'`)
  X: {
    priority: 10,
    parse: function(t, r, e, n) {
      switch (r) {
        case "X":
          return f(d.basicOptionalMinutes, t);
        case "XX":
          return f(d.basic, t);
        case "XXXX":
          return f(d.basicOptionalSeconds, t);
        case "XXXXX":
          return f(d.extendedOptionalSeconds, t);
        case "XXX":
        default:
          return f(d.extended, t);
      }
    },
    set: function(t, r, e, n) {
      return r.timestampIsSet ? t : new Date(t.getTime() - e);
    },
    incompatibleTokens: ["t", "T", "x"]
  },
  // Timezone (ISO-8601)
  x: {
    priority: 10,
    parse: function(t, r, e, n) {
      switch (r) {
        case "x":
          return f(d.basicOptionalMinutes, t);
        case "xx":
          return f(d.basic, t);
        case "xxxx":
          return f(d.basicOptionalSeconds, t);
        case "xxxxx":
          return f(d.extendedOptionalSeconds, t);
        case "xxx":
        default:
          return f(d.extended, t);
      }
    },
    set: function(t, r, e, n) {
      return r.timestampIsSet ? t : new Date(t.getTime() - e);
    },
    incompatibleTokens: ["t", "T", "X"]
  },
  // Seconds timestamp
  t: {
    priority: 40,
    parse: function(t, r, e, n) {
      return _(t);
    },
    set: function(t, r, e, n) {
      return [new Date(e * 1e3), {
        timestampIsSet: !0
      }];
    },
    incompatibleTokens: "*"
  },
  // Milliseconds timestamp
  T: {
    priority: 20,
    parse: function(t, r, e, n) {
      return _(t);
    },
    set: function(t, r, e, n) {
      return [new Date(e), {
        timestampIsSet: !0
      }];
    },
    incompatibleTokens: "*"
  }
};
export {
  P as default
};
//# sourceMappingURL=index211.mjs.map
